import { Link } from 'react-router-dom';
import NotificationBell from '../NotificationBell/NotificationBell';
import './BordPageHeader.scss';

export interface IBordPageBreadcrumbItem {
  label: string;
  href?: string;
}

interface IBordPageHeader {
  items: IBordPageBreadcrumbItem[];
}

/**
 * Header global de nueva generación. Reemplaza al Header clásico en rutas configuradas.
 * Renderiza un breadcrumb horizontal: los ítems con href son links navegables,
 * el último ítem (sin href) representa la página activa y se muestra en negrita.
 */
const BordPageHeader = ({ items }: IBordPageHeader) => (
  <nav className="bordPageHeader">
    <ol className="breadcrumbList">
      {items.map((item, index) => (
        <li key={index} className="breadcrumbItem">
          {index > 0 && <span className="separator">/</span>}
          {item.href ? (
            <Link to={item.href} className="breadcrumbLink">
              {item.label}
            </Link>
          ) : (
            <span className="breadcrumbCurrent">{item.label}</span>
          )}
        </li>
      ))}
    </ol>
    <NotificationBell />
  </nav>
);

export default BordPageHeader;
